import settings from '../settings.js'

const $inject = ['$rootScope', '$http', 'Idle']

function UserService(rootScope, http, Idle) {
    //Do we use dateOfBirth and/or guardianName&guardianSSN for this app?
    this.usePersonDateOfBirth = settings.usePersonDateOfBirth;
    this.usePersonGuardian = settings.usePersonGuardian;

    this.user = {};

    this.langCode = 'fi-FI'; //Use Finnish language by default.

    this.binaryVersion = null;

    //loginState
    //0 = Login not initiated or logged out
    //1 = Login currently in progress
    //2 = Login successful.
    this.loginData = {
        loginState: 0,
        isTagLogin: false, //Never in app
        serverSettingsFetched: false,
        tagData: {
            tagUID: false,
            techTypes: []
        },
        username: null,
        password: null
    };

    this.getLoginData = () => this.loginData;

    this.getLangCode = () => this.langCode;

    //Set the language being used in app
    this.setLanguage = (langCode, firstInit = false) => {
        if (langCode.toLowerCase() === 'fi-fi')
            langCode = 'fi-FI';

        if (langCode.toLowerCase() === 'sv-se')
            langCode = 'sv-SE';

        if (langCode.toLowerCase() === 'en-gb')
            langCode = 'en-GB';

        if (langCode.toLowerCase() === 'de-de')
            langCode = 'de-DE';    

        console.log(`[${performance.now()}] UserService.setLanguage(): received langCode '${langCode}'. Arg firstInit = ${(firstInit ? "TRUE" : "FALSE")}.`);        

        this.langCode = langCode;
        _setLanguage(this.langCode);

        //Save to localStorage, so that we can load selected language during next app startup
        localStorage.setItem('wiseLang-' + settings.appId, this.langCode);

        //Call server with Common\Localization::changeLocalization(), and set $_SESSION['language']
        //Note, this is probably unnecessary since we set lang=X elsewhere too, but lets be sure!
        http({
            method: 'GET',
            url: settings.baseUrl + '?setserverlang=1&langCode=' + this.langCode + '&appauth=' + settings.appAuthSecret
        }).then((response) => {
            if (response.data.success)
                console.log(`[${performance.now()}] Using language langId '${response.data.commonLangId}', language '${response.data.commonLanguage}', name '${response.data.commonName}'.`);
        });

        //Broadcast that we changed language.
        //Note, don't bother doing this when called from AppCtrl start. We have not yet had time to fetch data with potentially incorrect language.
        if (!firstInit)
            rootScope.$broadcast('language.changed', this.langCode);
    };

    this.setDetails = (details) => {
        for (const [key, value] of Object.entries(details)) {
            this.user[key] = value;
        }

        if (details.access_token) {
            http.defaults.headers.common['Authorization'] = `token ${ details.access_token }`;
        }
        else if (details.username && details.password) {
            http.defaults.headers.common['X-username'] = details.username;
            http.defaults.headers.common['X-password'] = details.password;
        }

        //This needs to be disabled for jumppakalenteri app
        //this.saveUser();
    };

    //Get all settings for current appId from MobileAppSettings. Overwrites defaults in client/settings.js
    //If user logged in, some settings can potentially be overwritten by user specific settings in MobileAppSettings_User
    this.getMobileAppSettings = () => {
        return new Promise((resolve, reject) => {

            //Just stringify objects for logging purposes. For Dev reasons only.
            const objLogFunc = (val) => {
                return (Array.isArray(val) || (typeof val === 'object' && val !== null)) ? JSON.stringify(val) : val;
            };

            const successHandler = (response) => {
                if (response.data) {
                    for (const [key, value] of Object.entries(response.data)) { //Check for local first
		                if (key === 'useLocalFitness') {
		                    settings[key] = value;
		                    break;
		                }
		            }

                    for (const [key, value] of Object.entries(response.data)) {
		                if (key === 'idle' && settings.useLocalFitness) { //Idle only if local
		                    if (value.timeout && value.timeout !== settings.idle.timeout)
		                        Idle.setTimeout(parseInt(value.timeout));

		                    if (value.warning && value.warning !== settings.idle.warning)
		                        Idle.setIdle(parseInt(value.warning));                            
		                }

                        //Check if the server setting value is actually different from hardcoded setting value?
                        if (!angular.equals(settings[key], value)) {
                            console.log(`getMobileAppSettings(): Change setting '${key}' from '${ objLogFunc(settings[key])}' to '${objLogFunc(value)}'`);

                            //For local, don't overwrite these
                            if (forceLocal && ['fitnessRequiresLogin', 'useLocalFitness'].includes(key)) {
                                continue
                            }

                            settings[key] = value;
                        }
                    }

		            this.loginData.serverSettingsFetched = true;
                }

                resolve(true);
            }

            console.log(`[${performance.now()}] Fetching MobileAppSettings for appId '${settings.appId}' from ${settings.baseUrl}`);

            http({
                method: 'POST',
                url: settings.baseUrl + '?getmobileappsettings=1&appid=' + settings.appId + '&appauth=' + settings.appAuthSecret,
                data: {
                    tagPersonId: (this.loginData.isTagLogin && this.loginData.loginState === 2) ? this.user.personId : false
                }
            }).then(successHandler, reject);
        });
    };

    this.updateSettings = (newSettings) => {
        const user = {
            personId: this.user.personId || false,
            username: this.user.username || false
        };

        return http({
            method: 'POST',
            url: settings.baseUrl + '?updateusersettings=1&appauth=' + settings.appAuthSecret,
            data: {
                appId: settings.appId,
                settings: newSettings,
                user: user,
                device: ionic.Platform.device(),
                appVersion: settings.appVersion,
                binaryVersion: null
            }
        });
    };

    this.saveUser = () => {
        localStorage.setItem('wise-' + settings.appId, JSON.stringify(this.user));
        
        //console.log(`[${performance.now()}] LocalStorage setItem(). ${'wise-' + settings.appId} set to ${JSON.stringify(this.user)}`);
    };

    this.loadUser = (setDetails = true) => {
        return new Promise((resolve, reject) => {
			const data = localStorage.getItem('wise-' + settings.appId);

            //console.log(`[${performance.now()}] LocalStorage getItem(). ${'wise-' + settings.appId} is ${JSON.stringify(data)}`);

			if (data && setDetails)
				this.setDetails(JSON.parse(data));

            resolve(!!data);
        });
    };

    //Verify session validity. 
    this.getSessionData = () => {
        return new Promise((resolve, reject) => {
            if (this.user.access_token) {
                http.defaults.headers.common['Authorization'] = `token ${ this.user.access_token }`;

                const successHandler = (response) => {
                    if (!response.data.success) { //$SESSION sessionId regenerated. New login required!
                        this.user = {};
                        
                        delete localStorage['wise-' + settings.appId];

                        http.defaults.headers.common['X-username'] = undefined;
                        http.defaults.headers.common['X-password'] = undefined;
                        http.defaults.headers.common['Authorization'] = undefined;

                        if (response.data.access_token)  //Set new sessionId
                            this.setDetails({access_token: response.data.access_token});

                        return resolve({
                            isValid: false,
                            data: response.data
                        });
                    }

                    console.log(`[${performance.now()}] getSessionData() success for user ${response.data.user.username}`);

                    const details = {
                        username: response.data.user.username,
                        personId: response.data.user.personId,
                        //firstName: response.data.user.firstName,
                        //lastName: response.data.user.familyName,
                        //phone: response.data.user.phone,
                        //streetAddress: response.data.user.streetAddress,
                        //postalCode: response.data.user.postalCode,
                        //city: response.data.user.city
                    };
                    
                    //details.password = this.user.password ? this.user.password : false;

                    if (response.data.access_token)
                        details.access_token = response.data.access_token;
        
                    this.setDetails(details);

                    return resolve({
                        isValid: true,
                        data: response.data
                    });
                };

                http({
                    method: 'POST',
                    url: settings.baseUrl + '?getsessiondata=1&appauth=' + settings.appAuthSecret
                }).then(successHandler).catch(reject);
            }
            else {
                reject('No access_token!');
            }
        });
    };

    //Do user authorize using username and password.
    this.authorize = (username, password) => {
        return new Promise((resolve, reject) => {
            this.loginData.loginState = 1;

            this.loginData.username = username;
            this.loginData.password = password;

            const successHandler = (response) => {
                const details = {
                    username: this.loginData.username,
                    password: this.loginData.password,
                    personId: response.data.personId,
                    firstName: response.data.firstName,
                    lastName: response.data.familyName,
                    phone: response.data.phone,
                    streetAddress: response.data.streetAddress,
                    postalCode: response.data.postalCode,
                    city: response.data.city
                };

                if (this.usePersonDateOfBirth)
                    details.dateOfBirth = response.data.dateOfBirth;

                if (this.usePersonGuardian) {
                    details.guardianName = response.data.guardianName;
                    details.guardianSSN = response.data.guardianSSN;
                }

                if (response.data.access_token)
                    details.access_token = response.data.access_token;

                this.setDetails(details);

                resolve(response);
            };

            const errorHandler = (response) => {
                this.loginData.loginState = 0; //Login failure
                reject(response);
            };

            console.log(`[${performance.now()}] Attempting to log username ${username} in to ${settings.baseUrl}`);

            http({
                method: 'POST',
                url: settings.baseUrl + '?action=ajaxauthorize&appauth=' + settings.appAuthSecret,
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Credentials': true
                },
                data: {
                    username: username,
                    password: password
                }
            }).then(successHandler).catch(errorHandler);
        });
    };

    this.logout = () => {
        return new Promise((resolve, reject) => {
            const logoutHandler = (response) => {
                this.user = {};
                this.loginData.loginState = 0;

                delete localStorage['wise-' + settings.appId];

                http.defaults.headers.common['X-username'] = undefined;
                http.defaults.headers.common['X-password'] = undefined;
                http.defaults.headers.common['Authorization'] = undefined;

                resolve(response.data);
            };

            console.log(`[${performance.now()}] Logging out from ${settings.baseUrl}`);

            http({
                method: 'GET',
                url: settings.baseUrl+'?action=logout&applogout=1&appauth=' + settings.appAuthSecret
            }).then(logoutHandler).catch(logoutHandler);
        });
    };

    this.forgotPassword = (username) => {
        return http({
            method: 'POST',
            url: settings.baseUrl + '?action=forgottenpassword&mode=requestnew&appauth=' + settings.appAuthSecret,
            data: {
                email: username
            }
        });
    };

    this.registerUser = (userData) => {
        return http({
            method: 'POST',
            url: settings.baseUrl+'?appregistration=1&appauth='+settings.appAuthSecret,
            data: userData
        });
    };

    this.changeUserDetails = (userData) => {
        return http({
            method: 'POST',
            url: settings.baseUrl+'?appuserdetail=1&appauth='+settings.appAuthSecret,
            data: userData
        });
    };

    this.doTagLogin = (tagData, locationId) => {
        return http({
            method: 'POST',
            url: settings.baseUrl + '?taglogin=1&appauth=' + settings.appAuthSecret,
            data: {
                tagData: tagData,
                locationId: locationId
            }
        });
    };
}

UserService.$inject = $inject;

export default UserService